import React from 'react';
import { SectionContainer, SectionTitle } from './styled';
export var Section = function Section(_ref) {
  var title = _ref.title,
    sectionId = _ref.sectionId,
    ariaLabelledby = _ref.ariaLabelledby,
    dataTestId = _ref.dataTestId,
    children = _ref.children,
    className = _ref.className;
  return /*#__PURE__*/React.createElement(SectionContainer, {
    className: className,
    role: "group",
    "aria-labelledby": ariaLabelledby,
    "data-test": dataTestId
  }, /*#__PURE__*/React.createElement(SectionTitle, {
    role: "heading",
    "aria-level": 3,
    id: sectionId
  }, title), children);
};